export const getVideoURL = (asset) => {
  const presets = asset?.presets || [];
  const playableUrl = (preset) => preset?.dlUrl || preset?.url || preset?.s3Url || null;
  const isMaster = (preset) => Number(preset?.presetId) === 0;

  const allPresets = presets.filter((x) => !isMaster(x));

  const lowestPreset = allPresets
    .map((preset) => {
      const presetName = preset?.name || preset?.description || preset?.key || '';
      const resolutionMatches = /\b(\d+)x(\d+)\b/.exec(presetName);
      const bitrateMatches = /\b(\d+)\s*kbps\b/i.exec(presetName);

      return {
        preset,
        width: resolutionMatches ? parseInt(resolutionMatches[1], 10) : Number.MAX_SAFE_INTEGER,
        height: resolutionMatches ? parseInt(resolutionMatches[2], 10) : Number.MAX_SAFE_INTEGER,
        bitrate: bitrateMatches ? parseInt(bitrateMatches[1], 10) : Number.MAX_SAFE_INTEGER,
      };
    })
    .filter(
      ({ preset, width, height }) =>
        playableUrl(preset) && width !== Number.MAX_SAFE_INTEGER && height !== Number.MAX_SAFE_INTEGER,
    )
    .sort((a, b) => a.height - b.height || a.width - b.width || a.bitrate - b.bitrate)[0];

  if (lowestPreset) {
    return playableUrl(lowestPreset.preset);
  } else {
    const isFallback = (preset) =>
      preset?.key?.toLowerCase() === 'fallback' ||
      preset?.name?.toLowerCase()?.includes('fallback') ||
      preset?.description?.toLowerCase()?.includes('fallback');

    const fallback_preset = presets.find((x) => isFallback(x));

    if (playableUrl(fallback_preset)) {
      return playableUrl(fallback_preset);
    }

    const master_preset = presets.find((x) => isMaster(x));

    if (playableUrl(master_preset)) {
      return playableUrl(master_preset);
    }

    if (playableUrl(allPresets[0])) {
      return playableUrl(allPresets[0]);
    }

    return null;
  }
};
